import styled, { css } from "styled-components";
export const FaqListStyled = styled.ul`
  width: 100%;
  @media (max-width: 1024px) {
    width: 100%;
  }
`;
